// Texty stránky Prodejna nářadí (storePage.js). Stránka existuje jen na CZ
// (`SHOP.pages.store` je na SK null) — dvojče žije kvůli tvaru (S3 #399).
export default {
  eshopCta: 'Přejít do e-shopu',
  visitCta: 'Naplánovat návštěvu',
  openToday: 'Otevřeno dnes',
  closedToday: 'Dnes zavřeno',
  choice: 'E-shop i osobní odběr',
  choicePerex:
    'Vyberte si, jak vám to vyhovuje. Ať nakoupíte online, nebo osobně, dostanete stejné férové ceny a poradenství.',
  online: 'Objednej online',
  onlineCta: 'Do e-shopu',
  pickup: 'Vyzvedni na prodejně',
  pickupText:
    'Preferujete osobní výběr? Zastavte se u nás. Nářadí si osaháte naživo, vyzkoušíte a společně vybereme nejlepší řešení. Osobní odběr je zdarma.',
  assort: 'Co u nás koupíte',
  assortHint: 'Kutilům i profesionálům',
  brands: 'Ověřené značky:',
  map: 'Kde nás najdete',
  address: 'Adresa',
  hours: 'Otevírací doba',
  mapCta: 'Zobrazit mapu',
  mapPill: 'Otevřít v mapách',
  video: 'Prodejna Jipos na vlastní oči',
  videoCap: 'Prodejna Jipos · Bílina',
  pickupFree: 'Osobní odběr zdarma',
  /** fallback CTA druhé volby, když administrace nenese vlastní odkaz */
  shippingLabel: 'Doprava a platba',
  heroAlt: 'Prodejna nářadí Jipos v Bílině',
  galleryAlt: 'Prodejna Jipos v Bílině',
  /** dlaždice „Co u nás koupíte" — pořadí = ASSORTMENT v modulu (icon/re zůstávají v kódu) */
  assortment: [
    { title: 'Ruční nářadí', desc: 'Klíče, kleště, sady bitů i měřicí technika.' },
    { title: 'Elektrické a aku nářadí', desc: 'Vrtačky, brusky, pily a aku systémy.' },
    { title: 'Zahradní technika', desc: 'Sekačky, křovinořezy, pily a kompresory.' },
    { title: 'Příslušenství', desc: 'Kotouče, vrtáky, řetězy a náhradní díly.' },
  ],
};
